import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { rejoinMapImages as t } from "./rejoinMapImages.mjs";
import { useQuery as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
import { useMemo as i } from "react";
import { canonicalZoom as a, snapBbox as o } from "@maat/utils";
//#region src/properties/useMapPropertiesQuery.ts
var s = (s) => {
	let c = i(() => s && {
		...s,
		zoom: a(s.zoom),
		bbox: o(s.bbox, s.zoom)
	}, [s]);
	return n({
		queryKey: e.map(c),
		queryFn: async () => {
			let e = await r.getMapProperties(c);
			return {
				...e,
				items: e.items.map((n) => t(n, e.imageBase))
			};
		},
		enabled: !!c?.bbox,
		placeholderData: (e) => e
	});
};
//#endregion
export { s as useMapPropertiesQuery };
